module.exports = __webpack_public_path__ + "media/food.a2473f6f.mp4";